import React from "react";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  TextField,
  Button,
  Box,
  Select,
  MenuItem,
  FormControl,
  InputLabel
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { ImageUpload } from "../../ImageUpload";

const OnboardingScreens = ({
  onboardingScreens,
  onScreenChange,
  onAddScreen,
  onRemoveScreen,
  isComplete = false
}) => {
  return (
    <Accordion>
      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <Typography variant="subtitle1">Onboarding Screens</Typography>
          {isComplete && <CheckCircleIcon color="success" />}
        </Box>
      </AccordionSummary>
      <AccordionDetails>
        <Typography variant="body2" color="text.secondary" gutterBottom>
          Configure the onboarding screens that users will see when joining this spending goal.
        </Typography>

        {onboardingScreens.map((screen, index) => (
          <Accordion key={screen.id || index} sx={{ mt: 2 }}>
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
              <Typography variant="subtitle2">
                Screen {index + 1}: {screen.title || screen.identifier}
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Box sx={{ display: "flex", gap: 2, mb: 2 }}>
                <FormControl sx={{ minWidth: 200 }}>
                  <InputLabel>Screen Type</InputLabel>
                  <Select
                    value={screen.identifier}
                    label="Screen Type"
                    onChange={(e) => onScreenChange(index, "identifier", e.target.value)}
                  >
                    <MenuItem value="InfoStepScreen">Info Step Screen</MenuItem>
                    <MenuItem value="GoalEntryScreen">Goal Entry Screen</MenuItem>
                    <MenuItem value="IntentionEntryScreen">Intention Entry Screen</MenuItem>
                    <MenuItem value="NotificationPromptScreen">Notification Prompt Screen</MenuItem>
                  </Select>
                </FormControl>
                <Button
                  variant="outlined"
                  color="error"
                  size="small"
                  onClick={() => onRemoveScreen(index)}
                >
                  Remove
                </Button>
              </Box>

              <TextField
                fullWidth
                label="Screen ID"
                margin="normal"
                value={screen.id}
                onChange={(e) => onScreenChange(index, "id", e.target.value)}
              />

              <TextField
                fullWidth
                label="Title"
                margin="normal"
                value={screen.title}
                onChange={(e) => onScreenChange(index, "title", e.target.value)}
              />

              <TextField
                fullWidth
                label="Subtitle"
                margin="normal"
                value={screen.subtitle}
                onChange={(e) => onScreenChange(index, "subtitle", e.target.value)}
              />

              <TextField
                fullWidth
                label="Body"
                margin="normal"
                multiline
                rows={3}
                value={screen.body}
                onChange={(e) => onScreenChange(index, "body", e.target.value)}
              />

              <Box sx={{ mt: 2, mb: 2 }}>
                <Typography variant="subtitle2" gutterBottom>
                  Icon
                </Typography>
                <Typography variant="body2" color="text.secondary" gutterBottom>
                  Drag and drop an image or click to select an image
                </Typography>
                <ImageUpload
                  image={screen.iconUrl}
                  onChange={({ target }) => onScreenChange(index, "iconUrl", target.value)}
                  name={`iconUrl_${index}`}
                  imageAlt={`screen ${index + 1} icon`}
                  ratio="1:1"
                  sx={{ width: "150px", height: "150px" }}
                />
              </Box>
            </AccordionDetails>
          </Accordion>
        ))}

        <Button
          variant="outlined"
          onClick={onAddScreen}
          sx={{ mt: 2 }}
        >
          Add Onboarding Screen
        </Button>
      </AccordionDetails>
    </Accordion>
  );
};

export default OnboardingScreens;
